module.exports = __webpack_public_path__ + "img/limpiar.3de63ca6.svg";